import axios from '../../axios'

// 角色增加院校选择
export const allSchoolList = (data) => {
    return axios({
        url: '/api/admin/allSchoolList',
        method: 'get',
        data
    })
}

// 考试院校管理
export const schoolList = (data) => {
    return axios({
        url: '/api/base/exam/school',
        method: 'get',
        data: data
    })
}

export const schoolSave = (data) => {
    return axios({
        url: '/api/base/exam/school',
        method: 'post',
        data: data
    })
}

export const schoolUpdate = (data) => {
    return axios({
        url: '/api/base/exam/school',
        method: 'put',
        data: data
    })
}

export const schoolDelete = (data) => {
    return axios({
        url: '/api/base/exam/school',
        method: 'delete',
        data: data
    })
}

// 院校详情
export const schoolInfo = (data) => {
    return axios({
        url: '/api/base/exam/school/info',
        method: 'get',
        data
    })
}

// 考试管理
export const getExamList = (data) => {
    return axios({
        url: '/api/exam/base/exam',
        method: 'get',
        data
    })
}

export const examSave = (data) => {
    return axios({
        url: '/api/exam/base/exam',
        method: 'post',
        data
    })
}
export const examUpdate = (data) => {
    return axios({
        url: '/api/exam/base/exam',
        method: 'put',
        data
    })
}
export const examDelete = (data) => {
    return axios({
        url: '/api/exam/base/exam',
        method: 'delete',
        data
    })
}

// 考试信息
export const examInfo = (data) => {
    return axios({
        url: '/api/exam/base/exam/info',
        method: 'get',
        data
    })
}

// 考试列表
export const examList = (data) => {
    return axios({
        url: '/api/exam/base/exam/list',
        method: 'get',
        data
    })
}

// 专业管理
export const profSave = (data) => {
    return axios({
        url: '/api/exam/base/prof',
        method: 'post',
        data
    })
}

export const getProfList = (data) => {
    return axios({
        url: '/api/exam/base/prof',
        method: 'get',
        data
    })
}

export const profUpdate = (data) => {
    return axios({
        url: '/api/exam/base/prof',
        method: 'put',
        data
    })
}

export const profDelete = (data) => {
    return axios({
        url: '/api/exam/base/prof',
        method: 'delete',
        data
    })
}

// 专业信息
export const profInfo = (data) => {
    return axios({
        url: '/api/exam/base/prof/info',
        method: 'get',
        data
    })
}

// 专业列表
export const profList = (data) => {
    return axios({
        url: '/api/exam/base/prof/list',
        method: 'get',
        data
    })
}

// 科目管理
export const subjectList = (data) => {
    return axios({
        url: '/api/exam/base/subject',
        method: 'get',
        data
    })
}
export const subjectSave = (data) => {
    return axios({
        url: '/api/exam/base/subject',
        method: 'post',
        data
    })
}
export const subjectDelete = (data) => {
    return axios({
        url: '/api/exam/base/subject',
        method: 'delete',
        data
    })
}
export const subjectUpdate = (data) => {
    return axios({
        url: '/api/exam/base/subject',
        method: 'put',
        data
    })
}

// 科目信息
export const subjectInfo = (data) => {
    return axios({
        url: '/api/exam/base/subject/info',
        method: 'get',
        data
    })
}

// 科目列表
export const subjectIist = (data) => {
    return axios({
        url: '/api/exam/base/subject/list',
        method: 'get',
        data
    })
}

// 题库管理
export const questionList = (data) => {
    return axios({
        url: '/api/exam/base/question',
        method: 'get',
        data
    })
}

export const questionSave = (data) => {
    return axios({
        url: '/api/exam/base/question',
        method: 'post',
        data
    })
}

export const questionUpdate = (data) => {
    return axios({
        url: '/api/exam/base/question',
        method: 'put',
        data
    })
}

export const questionDelete = (data) => {
    return axios({
        url: '/api/exam/base/question',
        method: 'delete',
        data
    })
}
// 考生报名查询
export const apply = (data) => {
    return axios({
        url: '/api/exam/user/apply',
        method: 'post',
        data
    })
}

// 科目考试视频查询
export const video = (data) => {
    return axios({
        url: '/api/exam/app/video',
        method: 'get',
        data
    })
}

export const carouselList = (data) => {
    return axios({
        url: '/api/base/carousel',
        method: 'get',
        data
    })
}
export const carouselSave = (data) => {
    return axios({
        url: '/api/base/carousel',
        method: 'post',
        data
    })
}

export const carouselUpdate = (data) => {
    return axios({
        url: '/api/base/carousel',
        method: 'put',
        data
    })
}

export const carouselDelete = (data) => {
    return axios({
        url: '/api/base/carousel',
        method: 'delete',
        data
    })
}
export const exportStudent = (data) => {
    return axios({
        url: '/api/exam/user/apply/export',
        method: 'get',
        data
    })
}
// 招考省份专业查询
export const provProfList = (data) => {
    return axios({
        url: '/api/exam/base/province/prof/list',
        method: 'get',
        data
    })
}
// 招考省份专业查询
export const provProfStat = (data) => {
    return axios({
        url: '/api/exam/user/apply/province/stat',
        method: 'get',
        data
    })
}



// WEBPACK FOOTER //
// ./src/http/moudules/olExam/olExam.js